import React from "react"

import StoryblokLink from "../../internal/storyblokLink/StoryblokLink"

const TransparentCTAButton = ({ buttonProps }) => {

  if(buttonProps && buttonProps.url && buttonProps.url.fieldtype && !buttonProps.isModal) {
    return (
      <StoryblokLink text={buttonProps.text} withClass={`btn ${buttonProps.textColor === "white" ? "transparent-white" : "start-green"}`} SBLinkData={buttonProps.url} />
    )
  }
  return (
    <div>
      {/* Handles if the CTA button links to a modal or if it's going to a url */}
      {buttonProps.isModal ? (
        <button
          className={`btn ${buttonProps.textColor === "white" ? "transparent-white" : "start-green"}`} 
          href="#"
          datapropmodal={buttonProps.modalId}
          datapropmodalblok={buttonProps.modal ? buttonProps.modal[0]._uid : null}
        >
          {buttonProps.text}
        </button>
      ) : (
        <a className={`btn ${buttonProps.textColor === "white" ? "transparent-white" : "start-green"}`} href={buttonProps.url && (buttonProps.url !== "" && buttonProps.url !== null) ? buttonProps.url : "javascript:void(0)"}>
          {buttonProps.text}
        </a>
      )}
      
    </div>
  )
}
  
export default TransparentCTAButton